import { createContext } from 'react';
export const PortalStateContext = /*#__PURE__*/createContext(null);
export const PortalDispatchContext = /*#__PURE__*/createContext(null);
//# sourceMappingURL=portal.js.map